/* LUMA Iluminación only (loaded by layout/lighting.liquid). Pack selector -> form quantity + sticky bar. */
(function () {
  function initCompare() {
    document.querySelectorAll('[data-lx-compare]').forEach(function (box) {
      var range = box.querySelector('.lx-compare__range');
      if (!range) return;
      function sync() { box.style.setProperty('--lx-pos', range.value + '%'); }
      range.addEventListener('input', sync);
      sync();
    });
  }

  function init() {
    initCompare();
    watchDrawer();
    fixDrawer();
    var packs = document.querySelectorAll('[data-lx-pack]');
    if (!packs.length) return;

    var quantity = document.querySelector('[data-lx-quantity]');
    var stickyLabel = document.querySelector('[data-lx-sticky-label]');
    var stickyPrice = document.querySelector('[data-lx-sticky-price]');

    function apply(input) {
      if (quantity) quantity.value = input.value;
      packs.forEach(function (pack) { pack.classList.toggle('is-selected', pack.contains(input)); });
      if (stickyLabel) stickyLabel.textContent = input.getAttribute('data-label');
      if (stickyPrice) stickyPrice.textContent = input.getAttribute('data-price');
    }

    packs.forEach(function (pack) {
      var input = pack.querySelector('input[type="radio"]');
      if (input) input.addEventListener('change', function () { apply(input); });
    });

    // Re-sync on load: the browser may restore a previously selected radio after back/forward.
    var checked = document.querySelector('[data-lx-pack] input:checked');
    if (checked) apply(checked);
  }

  // The cart drawer is rebuilt client-side from /cart.js (theme.js). For lighting items show the pack size and a clean title.
  function fixDrawer() {
    var itemsEl = document.querySelector('[data-cart-drawer-items]');
    var units = window.lxUnits;
    if (!itemsEl || !units) return;
    var lines = itemsEl.querySelectorAll('[data-cart-line]');
    if (!lines.length) return;
    fetch('/cart.js').then(function (res) { return res.json(); }).then(function (cart) {
      lines = itemsEl.querySelectorAll('[data-cart-line]');
      cart.items.forEach(function (item, i) {
        var info = units[item.product_id];
        var line = lines[i];
        if (!line) return;
        var variantEl = line.querySelector('.cart-line__variant');
        var titleEl = line.querySelector('.cart-line__title');
        if (info) {
          if (titleEl) titleEl.textContent = info.title;
          if (variantEl && (!item.variant_title || item.variant_title === 'Default Title')) variantEl.textContent = 'Pack x' + (item.quantity * info.units);
        } else if (variantEl && !item.variant_title) {
          variantEl.style.display = 'none';
        }
      });
    }).catch(function () {});
  }

  function watchDrawer() {
    var itemsEl = document.querySelector('[data-cart-drawer-items]');
    if (!itemsEl || !window.MutationObserver) return;
    var busy = false;
    new MutationObserver(function () {
      if (busy) return;
      busy = true;
      setTimeout(function () { busy = false; fixDrawer(); }, 0);
    }).observe(itemsEl, { childList: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
